import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStockLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('inventory/stock-list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
